// Gedeelde stempelkaart (8 slots) — geometrische verificatie-stempels met hoekmarkeringen.
// Statussen: LOCKED | PENDING | VERIFIED | MISSED. Geel = geverifieerd, nooit voor "gemist".
import { P11 } from "./p11shared";
import { useP11Lang } from "./p11lang";
import { TechnicalGlyph } from "./p11fx";

export default function P11StampCard({ stamps, compact = false }) {
  const { tt } = useP11Lang();
  const stateLabel = { VERIFIED: tt("verified"), PENDING: tt("pending"), MISSED: tt("missed"), LOCKED: tt("locked") };

  return (
    <div className={`grid grid-cols-4 ${compact ? "gap-2" : "gap-3"}`} data-testid="p11-stampcard">
      {(stamps || []).map((s) => {
        const verified = s.state === "VERIFIED";
        const pending = s.state === "PENDING";
        const missed = s.state === "MISSED";
        return (
          <div key={s.session_id}
            className={`relative aspect-square border flex flex-col items-center justify-center ${verified ? "p11-stamp-anim" : ""}`}
            style={{
              borderColor: verified ? P11.yellow : pending ? P11.gray2 : P11.border,
              background: verified ? "rgba(255,228,77,0.1)" : "transparent",
            }}
            data-testid={`p11-stamp-${s.number}`}>
            {/* hoekmarkeringen — technische "officieel record" signatuur */}
            {!compact && ["top-1 left-1", "top-1 right-1", "bottom-1 left-1", "bottom-1 right-1"].map((pos) => (
              <span key={pos} className={`absolute ${pos} w-1.5 h-1.5 border-t border-l ${pos.includes("right") ? "rotate-90" : ""} ${pos.includes("bottom") ? "-rotate-90" : ""} ${pos === "bottom-1 right-1" ? "rotate-180" : ""}`}
                style={{ borderColor: verified ? P11.yellow : "#3a3a3a" }} aria-hidden="true" />
            ))}
            <span className="p11-mono" style={{ fontSize: compact ? 18 : 26, color: verified ? P11.yellow : pending ? P11.gray2 : missed ? "#4d4d4d" : P11.gray }}>
              {String(s.number).padStart(2, "0")}
            </span>
            {verified && !compact && <span className="mt-1" aria-hidden="true"><TechnicalGlyph type="crosshair" size={11} active /></span>}
            {missed && !compact && <span className="mt-1 w-3 h-px" style={{ background: "#4d4d4d", transform: "rotate(-45deg)" }} aria-hidden="true" />}
            {!compact && <span className="p11-label mt-1.5" style={{ fontSize: 8, color: verified ? P11.yellow : pending ? P11.gray2 : P11.gray }}>{stateLabel[s.state]}</span>}
          </div>
        );
      })}
    </div>
  );
}
